import { render, staticRenderFns } from "./ExportXLS.vue?vue&type=template&id=3b0779a2"
import script from "./ExportXLS.vue?vue&type=script&lang=js"
export * from "./ExportXLS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports